'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _textColorUtils = require('../utils/textColorUtils');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SECONDARY = 'secondary';

function getBackgroundColor(use, coloring, hovered) {
  var accentColor = coloring.accentColor;

  var _hexToRgb = (0, _textColorUtils.hexToRgb)(accentColor),
      r = _hexToRgb.r,
      g = _hexToRgb.g,
      b = _hexToRgb.b;

  if (use === SECONDARY) {
    if (hovered) {
      return 'rgba(' + r + ',' + g + ',' + b + ', 0.15)';
    }

    return undefined;
  }

  if (hovered) {
    return 'rgba(' + r + ',' + g + ',' + b + ', 0.85)';
  }

  return 'rgba(' + r + ',' + g + ',' + b + ', 1)';
}

function makeStyles(use, coloring, hovered) {
  var accentColor = coloring.accentColor,
      textColor = coloring.textColor;


  return {
    width: 'auto',
    minHeight: 36,
    borderColor: accentColor,
    whiteSpace: 'normal',
    lineHeight: '1rem',
    backgroundColor: getBackgroundColor(use, coloring, hovered),
    color: use === SECONDARY ? accentColor : textColor
  };
}

var QuickReply = _react2.default.createClass({
  displayName: 'QuickReply',

  propTypes: {
    children: _react.PropTypes.node.isRequired,
    coloring: (0, _RecordPropType2.default)('ColoringRecord'),
    disabled: _react.PropTypes.bool.isRequired,
    onClick: _react.PropTypes.func.isRequired,
    use: _react.PropTypes.string.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      use: SECONDARY,
      disabled: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      hovered: false
    };
  },
  handleMouseEnter: function handleMouseEnter() {
    this.setState({ hovered: true });
  },
  handleMouseLeave: function handleMouseLeave() {
    this.setState({ hovered: false });
  },
  render: function render() {
    var _props = this.props,
        onClick = _props.onClick,
        children = _props.children,
        disabled = _props.disabled,
        use = _props.use,
        coloring = _props.coloring;
    var hovered = this.state.hovered;


    var styles = makeStyles(use, coloring, hovered);

    return _react2.default.createElement(
      _UIButton2.default,
      {
        className: 'quick-reply display-inline-flex m-top-0 m-bottom-2 m-right-2',
        style: styles,
        size: 'small',
        use: use,
        onClick: onClick,
        disabled: disabled,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      },
      children
    );
  }
});

exports.default = QuickReply;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/QuickReply.js
// module id = 1127
// module chunks = 2 3